module.exports = __webpack_public_path__ + "img/ca9e46e.png";